import React from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import LanguageSelector from "../LanguageSelector";
import { useTranslation } from "react-i18next";

import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import Grid from "@mui/material/Grid";

import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Tooltip from "@mui/material/Tooltip";

const StyledIconButton = withStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      padding: "12px 6px",
    },
  },
}))(IconButton);

const useStyles = makeStyles((theme) => ({
  menuButton: {
    [theme.breakpoints.up("md")]: { display: "none" },
    [theme.breakpoints.up("sm")]: {
      marginRight: theme.spacing(2),
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
  },
  badgeColor: { backgroundColor: "#d1495b" },
  logo: {
    [theme.breakpoints.up("sm")]: {
      width: 168,
      height: 34,
    },
    [theme.breakpoints.down("sm")]: {
      width: 109,
      height: 22,
    },
  },
}));

export const NavToolbar = ({
  selectedNav,
  unreadNotifications,
  invisible,
  handleDrawerToggle,
  setMobileOpen,
  updateSelectedNav,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  NavToolbar.propTypes = {
    unreadNotifications: PropTypes.number.isRequired,
    selectedNav: PropTypes.string.isRequired,
    invisible: PropTypes.bool.isRequired,
    handleDrawerToggle: PropTypes.func.isRequired,
    setMobileOpen: PropTypes.func.isRequired,
    updateSelectedNav: PropTypes.func.isRequired,
  };

  return (
    <Toolbar>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        onClick={handleDrawerToggle}
        className={classes.menuButton}
        size="large"
      >
        <MenuIcon style={{ color: "#76bc21" }} />
      </IconButton>
      <RouterLink to="/">
        <img
          className={classes.logo}
          src={"./src/_images/LogoLimited.png"}
          alt="LifeSafer"
          onClick={() => {
            updateSelectedNav("/");
          }}
        />
      </RouterLink>
      <Grid container direction="row" justifyContent="flex-end" alignItems="center">
        <Grid item>
          <LanguageSelector />
        </Grid>
        <Grid item>
          <Tooltip title={t("navigation.notifications")}>
            <StyledIconButton
              aria-label="show new notifications"
              color="inherit"
              component={RouterLink}
              to={"notifications"}
              onClick={() => {
                setMobileOpen(false);
                updateSelectedNav("/notifications");
              }}
            >
              <Badge
                badgeContent={unreadNotifications}
                classes={{ badge: classes.badgeColor }}
              >
                {selectedNav === "/notifications" ? (
                  <NotificationsIcon
                    style={{ color: "#76bc21" }}
                    fontSize="large"
                  />
                ) : (
                  <NotificationsIcon
                    style={{ color: "#1c355e" }}
                    fontSize="large"
                  />
                )}
              </Badge>
            </StyledIconButton>
          </Tooltip>
        </Grid>
        <Grid item>
          <Tooltip title={t("navigation.profile")}>
            <StyledIconButton
              edge="end"
              aria-label="account of current user"
              aria-haspopup="true"
              color="inherit"
              component={RouterLink}
              to={"profile"}
              onClick={() => {
                setMobileOpen(false);
                updateSelectedNav("/profile");
              }}
            >
              <Badge
                invisible={invisible}
                badgeContent={"!"}
                classes={{ badge: classes.badgeColor }}
              >
                {selectedNav === "/profile" ? (
                  <AccountCircle
                    style={{ color: "#76bc21" }}
                    fontSize="large"
                  />
                ) : (
                  <AccountCircle
                    style={{ color: "#1c355e" }}
                    fontSize="large"
                  />
                )}
              </Badge>
            </StyledIconButton>
          </Tooltip>
        </Grid>
      </Grid>
    </Toolbar>
  );
};
